import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { authorityAreaPathName, citizenAreaPathName } from '../authority/citizen-authority-area-pathnames';

/**
 * Redirects old standalone URLs to new authority structure
 * /standalone/citizen/:id -> /citizen/authority/:id/details
 * /standalone/citizen/:id/... -> /citizen/authority/:id/...
 */
export function StandaloneToAuthorityRedirect() {
  const location = useLocation();

  let newPath = location.pathname
    .replace('/standalone/', '/')
    .replace(`/${citizenAreaPathName}/`, `/${citizenAreaPathName}/${authorityAreaPathName}/`);

  // Check if URL is exactly /citizen/authority/:id (no subpath after the ID)
  const isExactCitizenMatch = /^\/citizen\/authority\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/i.test(newPath);

  if (isExactCitizenMatch) {
    newPath = `${newPath.replace(/\/$/, '')}/details`;
  }

  return <Redirect to={{ pathname: newPath, search: location.search }} />;
}

/**
 * Redirects old embedded URLs to new authority structure
 * /embedded/citizen/:id -> /citizen/authority/:id/details
 * /embedded/citizen/:id/... -> /citizen/authority/:id/...
 */
export function EmbeddedToAuthorityRedirect() {
  const location = useLocation();

  let newPath = location.pathname
    .replace('/embedded/', '/')
    .replace(`/${citizenAreaPathName}/`, `/${citizenAreaPathName}/${authorityAreaPathName}/`);

  // Check if URL is exactly /citizen/authority/:id (no subpath after the ID)
  const isExactCitizenMatch = /^\/citizen\/authority\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/i.test(newPath);

  if (isExactCitizenMatch) {
    newPath = `${newPath.replace(/\/$/, '')}/details`;
  }

  return <Redirect to={{ pathname: newPath, search: location.search }} />;
}

/**
 * Redirects old citizen URLs to new authority structure
 * /citizen/:id -> /citizen/authority/:id/details
 * /citizen/:id/... -> /citizen/authority/:id/...
 */
export function CitizenToAuthorityRedirect() {
  const location = useLocation();

  // Check if URL is exactly /citizen/:id (no subpath after the ID)
  const isExactCitizenMatch = /^\/citizen\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/i.test(location.pathname);

  let newPath = location.pathname.replace(
    `/${citizenAreaPathName}/`,
    `/${citizenAreaPathName}/${authorityAreaPathName}/`
  );

  // If exact match (just citizen ID), append /details
  if (isExactCitizenMatch) {
    newPath = `${newPath.replace(/\/$/, '')}/details`;
  }

  return <Redirect to={{ pathname: newPath, search: location.search }} />;
}
